import React from 'react';

export default ({name, image, description, sku, price, url}) => {
	const descriptions = Array.isArray(description)
  ? description
      .map(block => Array.isArray(block.children) 
        ? block.children.map(child => child.text).join(' ') 
        : '')
      .join(' ')
  : '';
	const schema = {
		'@context': 'https://schema.org/',
		'@type': 'Review',
		sku,
		mpn: sku,
		itemReviewed: {
			'@type': 'Product',
			image: image,
			name: name,
			description: descriptions,
			offers: {
				'@type': 'Offer',
				url,
				priceCurrency: 'USD',
				price,
				itemCondition: 'https://schema.org/NewCondition',
				availability: 'https://schema.org/InStock',
				seller: {
					'@type': 'Organization',
					name: 'Genexa',
				},
			},
		},
		brand: {
			'@type': 'Thing',
			name: 'Genexa',
		},

		author: {
			'@type': 'Organization',
			name: 'Genexa',
		},
		publisher: {
			'@type': 'Organization',
			name: 'Genexa',
		},
	};

	return (
		<div
			dangerouslySetInnerHTML={{
				__html: `<script type="application/ld+json">${JSON.stringify(
					schema,
				)}</script>`,
			}}
		/>
	);
};